const percentageOptions = Array.from({ length: 40 }, (_, i) => (i + 1) * 10);

const formatOptions = (options, minValue, maxValue, type) => {
  return (type === 'to' ? options.slice(1) : options.slice(0, -1))
    .filter(option => option >= minValue && (maxValue === 0 || option <= maxValue))
    .map(option => ({
      label: new Intl.NumberFormat('en-US').format(option),
      value: option,
    }));
}

export const getOptions = (optionsList, minValue = 0, maxValue = 0, type = 'from') => {
  return formatOptions(optionsList, minValue, maxValue, type);
}

export const getFollowersOptions = (minValue = 0, maxValue = 0, type = 'from') => {
  const followersOptions = [
    1000, 5000, 10000, 25000, 35000, 50000, 100000, 250000, 500000,
    1000000, 2500000, 5000000, 10000000, 25000000, 50000000, 100000000,
  ];
  return getOptions(followersOptions, minValue, maxValue, type);
}

export const getReelsPlaysOptions = (minValue = 0, maxValue = 0, type = 'from') => {
  const reelsPlaysOptions = [
    1000, 3000, 5000, 10000, 15000, 20000, 25000, 35000, 50000, 75000,
    100000, 125000, 150000, 175000, 200000, 250000, 300000, 350000,
    500000, 1000000, 2000000, 3000000
  ];
  return getOptions(reelsPlaysOptions, minValue, maxValue, type);
}

export const getSavesOptions = (minValue = 0, maxValue = 0, type = 'from') => {
  const savesOptions = [
    100, 200, 300, 400, 500, 1000, 5000, 10000, 50000, 100000,
    500000, 1000000,
  ];
  return getOptions(savesOptions, minValue, maxValue, type);
}

export const getGenderOptions = (onlyMaleFemale = false) => {
  const genderOptions = [
    { label: 'Female', value: 'FEMALE' },
    { label: 'Male', value: 'MALE' },
  ];

  return onlyMaleFemale
    ? genderOptions
    : [...genderOptions,
    { label: 'Gender Neutral', value: 'UNKNOWN' },
    { label: 'Female or Male', value: 'KNOWN' },
    ];
}

export const getAgeOptions = (minValue = 0, maxValue = 0) => {
  const options = [18, 25, 35, 45];
  return options
    .filter(option => option >= minValue && (maxValue === 0 || option <= maxValue))
    .map(option => ({ label: option, value: option }));
}

export const getAudienceAgeOptions = () => [
  { label: '13-17', value: '13-17' },
  { label: '18-24', value: '18-24' },
  { label: '25-34', value: '25-34' },
  { label: '35-44', value: '35-44' },
  { label: '45+', value: '45-64' },
];

export const getLastPostedOptions = () => [
  { label: '30 days', value: 30 },
  { label: '3 months', value: 90 },
  { label: '6 months', value: 180 },
];

export const getEngagementRateOptions = () => [
  { label: '≥0.5%', value: 0.005 },
  { label: '≥1%', value: 0.01 },
  { label: '≥2% (average)', value: 0.02 },
  { label: '≥3%', value: 0.03 },
  { label: '≥4%', value: 0.04 },
  { label: '≥5%', value: 0.05 },
  { label: '≥6%', value: 0.06 },
  { label: '≥7%', value: 0.07 },
  { label: '≥8%', value: 0.08 },
  { label: '≥9%', value: 0.09 },
  { label: '≥10%', value: 0.1 },
];

export const getContactInformationOptions = () => {
  const platforms = [
    'Email', 'YouTube', 'TikTok', 'Twitch', 'X', 'Facebook', 'Snapchat',
    'Linktree', 'Kakao', 'Kik', 'Line ID', 'Pinterest', 'Sarahah', 'Sayat',
    'Tumblr', 'VK', 'WeChat', 'Skype', 'Bbm',
  ];

  return platforms.map(platform => ({
    label: platform,
    value: platform.toLowerCase().replace(' ', ''),
  }));
}

export const getFollowerGrowthRateIntervalOptions = () =>
  Array.from({ length: 6 }, (_, i) => ({
    label: `${i + 1} month${i ? 's' : ''}`,
    value: `i${i + 1}months`,
  }));

export const getFollowerGrowthRateOptions = () => [
  ...percentageOptions.map(value => ({
    label: `>${value}%`,
    value: { operator: 'gt', value },
  })),
  ...Array.from({ length: 50 }, (_, i) => ({
    label: `<${(i + 1) * 10}%`,
    value: { operator: 'lt', value: (i + 1) * 10 },
  })),
];

export const getAccountTypeOptions = () => [
  { label: 'Regular', value: 1 },
  { label: 'Business', value: 2 },
  { label: 'Creator', value: 3 },
];

export const getVerifiedOptions = () => [
  { label: 'Is verified', value: true },
];

export const getSponsoredPostsOptions = () => [
  { label: 'Has sponsored posts', value: true },
  { label: "Doesn't have sponsored posts", value: false },
];

export const getWeights = () =>
  Array.from({ length: 19 }, (_, i) => ({
    label: `≥${(i + 1) * 5}%`,
    value: (i + 1) * 0.05,
  }));

export const getCredibilityOptions = () => [
  { label: '≤ 25%', value: 0.75 },
  { label: '≤ 35%', value: 0.65 },
  { label: '≤ 50%', value: 0.5 },
];

export const getSortOptions = () => [
  { label: 'Followers', value: 'followers' },
  { label: 'Engagements', value: 'engagements' },
  { label: 'Engagement rate', value: 'engagementRate' },
];
